export const SEARCH: string = 'DOGLEY/SEARCH'
